/*eslint no-use-before-define:0 *///TODO REMOVE THIS
var dd = require('ES/lib/dd');
var _ = require('ES/lib/lodash');
var radio = require('ES/lib/radio');
var esUtils = require('ES/utils/esUtils');
var RadioMixin = require('ES/utils/RadioMixin');
var ErrorAlert = require('ES/widgets/ErrorAlert');
var LoadingWrap = require('ES/widgets/LoadingWrap');
var AuthedUserSession = require('../../../utils/AuthedUserSession');

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {sid: -1, has_award_wallet_connected: null, is_reading: false, read_error_msg: null};
  },
  componentWillReceiveProps: function (props) {
    this.__loadForSid(props.selected_sid);
  },
  componentDidMount: function () {
    this.__loadForSid(this.props.selected_sid);
  },
  __loadForSid: function (sid) {
    if (sid != this.state.sid) {
      this.setState({sid: sid, has_award_wallet_connected: null, is_reading: false, read_error_msg: null}, function () {
        radio('read_Thirdpartyconnection_AwardWallet_config').broadcast(sid);
      });
    }
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      read_Thirdpartyconnection_AwardWallet_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({has_award_wallet_connected: null, is_reading: true, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_AwardWallet_config_succeeded: function (sid, has_it) {
        if (self.state.sid == sid) {
          self.setState({has_award_wallet_connected: !!has_it, is_reading: false, read_error_msg: null});
        }
      },
      read_Thirdpartyconnection_AwardWallet_config_failed: function (sid, message) {
        if (self.state.sid == sid) {
          self.setState({has_award_wallet_connected: null, is_reading: false, read_error_msg: 'Failed to read your Award Wallet connector settings: ' + message});
        }
      }
    };
  },
  __removeAwardWalletConfig: function (sid) {
    let self = this;
    if (sid == this.state.sid) {
      radio("remove_Thirdpartyconnection_AwardWallet_config").broadcast(
        sid,
        function (sid, data) {
          self.setState({
            has_award_wallet_connected: false,
            is_reading: false,
            read_error_msg: null,
          });
        },
        function (sid, data) {
          self.setState({
            has_award_wallet_connected: true,
            is_reading: false,
            read_error_msg: _.get(data, "message", "Unknown error."),
          });
        }
      );
    }
  },
  render: function () {
    var Displaylists = this.props.Displaylists;
    var speaker = _.find(Displaylists && Displaylists.perspeaker, function (spkr) {
      return spkr.sid == this.state.sid;
    }, this);

    let connect_url =
      "/balboa3/thirdpartyconnection/configawardwallet/" +
      this.state.sid +
      "/start_oauth?" +
      esUtils.phpCompatibleParams(AuthedUserSession.balboa);

    return dd.div(null,
      LoadingWrap({is_loading: this.state.is_reading, glass: true},
        dd.h3(null, 'AwardWallet connector for ',
          dd.span({className: 'nametag'},
            AuthedUserSession.MY_USERNAME),
          ' + ',
          dd.span({className: 'nametag'},
            speaker ? speaker.name_full : '')
        ),
        dd.p({className: 'text-muted'},
          'NOTE: The settings for this connector is for A SPEAKER, rather than for your username. ',
          'If your username is attached to more than one speaker, you\'ll need to configure each speaker individually.'
        ),
        ErrorAlert({message: this.state.read_error_msg}),
        this.state.has_award_wallet_connected === true
          ? dd.div(
            null,
            dd.div(
              { className: "alert alert-success" },
              "You are connected to AwardWallet!"
            ),
            dd.p(
              {},
              dd.a(
                { href: connect_url },
                "Click here to CHANGE the AwardWallet account to which you are connected."
              )
            ),
            dd.p(
              {},
              dd.a(
                {
                  href: '#',
                  onClick: this.__removeAwardWalletConfig.bind(
                    this,
                    this.state.sid
                  ),
                },
                "Click here to DISCONNECT your AwardWallet account."
              )
            )
          )
          : dd.div(
            null,
            dd.p(
              null,
              "The link below will take you to AwardWallet's site, where you can sign in with your AwardWallet credentials."
            ),
            dd.p(
              null,
              "AwardWallet will ask if it's OK for eSpeakers to access your contacts, and you should ",
              dd.b(null, "choose ALLOW ACCESS.")
            ),
            dd.a(
              { href: connect_url, className: "btn btn-primary" },
              "Connect to your AwardWallet account"
            ),
            dd.br(),
            dd.br()
          )
      )
    );
  }
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/AwardWallet.js